// src/hooks/useChatApi.ts
import type { ApiResponse } from "../types/chat";

type OverrideDates = {
  startD?: Date;
  endD?: Date;
};

type Args = {
  selectedProjectId: number | null | undefined;
  startD: Date;
  endD: Date;
  chatId: string | null;
  formatToApiDate: (d: Date) => string;
};

export function useChatApi({ selectedProjectId, startD, endD, chatId, formatToApiDate }: Args) {
  const sendMsgRequest = async (
    query: string,
    overrideDates?: OverrideDates,
    diagnosisId?: string | null,
    aiSuggestionMode = false
  ): Promise<ApiResponse> => {
    const base = process.env.REACT_APP_BACKEND_URL;
    const url = `${base}/chat-main`;

    const effectiveStart = overrideDates?.startD ?? startD;
    const effectiveEnd = overrideDates?.endD ?? endD;

    const payload = {
      project_id: selectedProjectId,
      message: query,
      start_date: formatToApiDate(effectiveStart),
      end_date: formatToApiDate(effectiveEnd),
      chat_id: chatId,
      diagnosis_id: diagnosisId || null,
      ai_suggestion_mode: aiSuggestionMode,
    };

    const res = await fetch(url, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const errText = await res.text().catch(() => "");
      console.error("APIレスポンスがエラー:", res.status, res.statusText, errText);
      throw new Error("APIレスポンスがエラー");
    }

    return (await res.json()) as ApiResponse;
  };

  return { sendMsgRequest };
}
